@if (compactOnMobile && isMobile) {
  <div [ngClass]="overlayBG ? 'overlayBG' : 'panelBG'" class="searchBarCompact" role="button" tabindex="0"
    (click)="openSheet()" (keydown.enter)="openSheet()">
    <div [innerHTML]="icons['monitoring-outline']" class="searchBarCompact__icon" aria-hidden="true"></div>
    <span class="searchBarCompact__range">
      @if (buttonToggleSelected !== null && filterPeriods.includes(buttonToggleSelected)) {
        {{ 'GENERAL.HOURS_LAST' | translate }} {{ buttonToggleSelected }}{{ 'GENERAL.HOURS_H' | translate }}
      } @else if (formDate.controls.startDate.value && formDate.controls.endDate.value) {
        {{ formDate.controls.startDate.value | date: 'dd/MM HH:mm' }} → {{ formDate.controls.endDate.value | date: 'dd/MM HH:mm' }}
      } @else {
        —
      }
    </span>
    <button type="button" mat-button class="btn outlineActionButton searchBarCompact__btn"
      (click)="$event.stopPropagation(); openSheet()">
      {{ 'GENERAL.FILTER' | translate }}
    </button>
  </div>
} @else {
  <div [ngClass]="overlayBG ? 'overlayBG' : 'panelBG'"
    class="d-md-inline-flex d-block-flex flex-sm-wrap align-items-center searchBar">
    <ng-container [ngTemplateOutlet]="searchFields" [ngTemplateOutletContext]="{ pickerMode: 'popup' }"></ng-container>
  </div>
}

<ng-template #searchSheet>
  <div class="searchSheet">
    <div urbanSheetGrab></div>
    <div class="searchSheet__header">
      <span class="searchSheet__title">{{ 'GENERAL.FILTER' | translate }}</span>
      <button type="button" class="btn smallOutlineActionButton" (click)="closeSheet()">
        <div [innerHTML]="icons['close']" class="smallButtonIcon"></div>
      </button>
    </div>
    <ng-container [ngTemplateOutlet]="searchFields" [ngTemplateOutletContext]="{ pickerMode: 'dialog' }"></ng-container>
  </div>
</ng-template>

<ng-template #searchFields let-pickerMode="pickerMode">
  <form [formGroup]="formDate" class="mr-3">
    <mat-form-field appearance="outline" class="customDatePicker mr-3 mb-3 mb-md-0">
      <mat-label>{{'GENERAL.START_DATE' | translate }}</mat-label>
      <input formControlName="startDate" matInput [owlDateTime]="dt1" [min]="this.minStartDate"
        [max]="this.maxStartDate" [owlDateTimeTrigger]="dt1" readonly
        (dateTimeChange)="onStartDateUpdate($event.value); removeRangeBtnActive()">

      <div [innerHTML]="icons['monitoring-outline']" class="calendarIcon"
      [owlDateTimeTrigger]="dt1" matSuffix (click)="onBlankDatesFocus()"></div>

      <owl-date-time #dt1 [pickerMode]="pickerMode"></owl-date-time>
    </mat-form-field>

    <mat-form-field appearance="outline" class="customDatePicker">
      <mat-label>{{'GENERAL.END_DATE' | translate }}</mat-label>
      <input formControlName="endDate" matInput [owlDateTime]="dt2" [min]="this.minEndDate"
        [max]="this.maxEndDate" [owlDateTimeTrigger]="dt2" readonly
        (dateTimeChange)="onEndDateUpdate($event.value); removeRangeBtnActive()">

      <div [innerHTML]="icons['monitoring-outline']" class="calendarIcon"
      [owlDateTimeTrigger]="dt2" matSuffix (click)="onBlankDatesFocus()"></div>

      <owl-date-time #dt2 [pickerMode]="pickerMode"></owl-date-time>
    </mat-form-field>
  </form>

  <div class="mr-4 mb-4 mb-md-0 searchActions">
    <button type="submit"  class="btn mb-3 smallActionButton" [disabled]="loadingEvents !== false" (click)="onSearch()"
      matTooltip="{{ 'WEATHERSTATION.SEARCH' | translate }}">
      <div [innerHTML]="icons['search']" class="smallButtonIcon"></div>
    </button>
    <button type="submit" class="btn smallOutlineActionButton marginClearBtn mb-3" (click)="clearDateAndUnsubscribe()"
      matTooltip="{{'GENERAL.CLEAR_ALL' | translate }}">
      <div [innerHTML]="icons['close']" class="smallButtonIcon"></div>
    </button>
  </div>

  <div>
    <mat-button-toggle-group aria-label="Time Range Set" class="searchRangeBtn mb-4" hideSingleSelectionIndicator="true"
      (valueChange)="setTimeRange($event)" [(ngModel)]="buttonToggleSelected">
      @for (period of filterPeriods; track period) {
        <mat-button-toggle [value]="period" [disabled]="loadingEvents !== false">
          <div
            [ngClass]="{'button-toggle-wrap lineheightIT' : currentLanguage === 'it', 'fontSizeToggleEn' : currentLanguage === 'en'}">
            <span [ngClass]="{'uppercaseText' : currentLanguage === 'it'}">{{'GENERAL.HOURS_LAST' | translate}}
              </span><span>{{period}}{{'GENERAL.HOURS_H' | translate}}</span></div>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
</ng-template>
